// const ArgumentType = require('../../extension-support/argument-type');
// const BlockType = require('../../extension-support/block-type');
// const formatMessage = require('format-message');
// const axios = require('axios');

// const HEADER_TEMPLATE = `
// #include <Wire.h>
// #include <Adafruit_PWMServoDriver.h>

// #define PCA9685_ADDR 0x40 // I2C address of PCA9685 module
// Adafruit_PWMServoDriver pwm = Adafruit_PWMServoDriver(PCA9685_ADDR);

// #define SERVOMIN_puls 170
// #define SERVOMAX_puls 600
// #define SERVOMIN_angle 5
// #define SERVOMAX_angle 180

// const int coksa1_s= 0;
// const int coksa2_s= 4;
// const int coksa3_s= 8;
// const int coksa4_s= 12;

// const int tibia1_s= 1;
// const int tibia2_s= 5;
// const int tibia3_s= 9;
// const int tibia4_s= 13;

// const int femur1_s= 2;
// const int femur2_s= 6;
// const int femur3_s= 10;
// const int femur4_s= 14;

// uint16_t angleToPulse(int angle) {
//   return map(angle, SERVOMIN_angle, SERVOMAX_angle, SERVOMIN_puls, SERVOMAX_puls);
// }`;
// const SETUP_TEMPLATE = `void setup() { Serial.begin(9600);
//   pwm.begin();
//   pwm.setPWMFreq(60);
//   delay(10);
//   loop();
//   delay(1000); }\n`;
// const LOOP_TEMPLATE = `void loop() {\n{loopCode}\n}\n`;
// const DEFINE_TEMPLATE = `{defineCode}\n`;

// let setupCode = '';
// let loopCode = '';
// let defineCode = '';
// let headerCode = '';
// let initializedPins = new Set();

// class Scratch3ArduinoUnoBlocks {
//     constructor(runtime) {
//         this.runtime = runtime;
//     }
 
//     getInfo() {
//         return {
//             id: 'spider',
//             name: formatMessage({
//                 id: 'spider.categoryName',
//                 default: 'Robo-Spider',
//                 description: 'Arduino Uno extension category'
//             }),
//             blocks: [
//                 {
//                     opcode: 'homePosition',
//                     blockType: BlockType.COMMAND,
//                     text: formatMessage({
//                         id: 'arduinouno.homePosition',
//                         default: 'Move Spider to home position',
//                         description: 'Move servos to home position'
//                     })
//                 },
//                 {
//                     opcode: 'moveDown',
//                     blockType: BlockType.COMMAND,
//                     text: formatMessage({
//                         id: 'arduinouno.moveDown',
//                         default: 'Move Spider to down position',
//                         description: 'Move servos to down position'
//                     })
//                 },
//                 {
//                     opcode: 'moveDownExtreme',
//                     blockType: BlockType.COMMAND,
//                     text: formatMessage({
//                         id: 'arduinouno.moveDownExtreme',
//                         default: 'Move Spder to extreme down position',
//                         description: 'Move servos to extreme down position'
//                     })
//                 },
//                 {
//                     opcode: 'moveUp',
//                     blockType: BlockType.COMMAND,
//                     text: formatMessage({
//                         id: 'arduinouno.moveUp',
//                         default: 'Move Spider to up position',
//                         description: 'Move servos to up position'
//                     })
//                 },
//                 {
//                     opcode: 'twist',
//                     blockType: BlockType.COMMAND,
//                     text: formatMessage({
//                         id: 'arduinouno.twist',
//                         default: 'Twist Spider',
//                         description: 'Twist servos'
//                     })
//                 }
//             ],
//             menus: {}
//         };
//     }

//     accumulateCode() {
//         return `
// ${HEADER_TEMPLATE}
// ${DEFINE_TEMPLATE.replace('{defineCode}', defineCode)}
// ${SETUP_TEMPLATE.replace('{setupCode}', setupCode)}
// ${LOOP_TEMPLATE.replace('{loopCode}', loopCode)}
//         `;
//     }

//     resetTemplates() {
//         setupCode = '';
//         loopCode = '';
//         defineCode = '';
//         initializedPins = new Set();
//     }

//     async generateAndUploadCode() {
//         const finalCode = this.accumulateCode();

//         console.log('Generated Arduino Code:', finalCode);

//         try {
//             const response = await axios.post('http://localhost:3500/iot/burnCode', {
//                 code: finalCode,
//                 deviceType: 'arduino',
//                 board: 'arduino:avr:uno'
//             });

//             console.log('Code successfully burned to the board');
//         } catch (error) {
//             console.error(`Error burning code: ${error}`);
//         }

//         // Reset templates after burning code
//         this.resetTemplates();
//     }

//     homePosition() {
       
//     loopCode +=` pwm.setPWM(coksa1_s, 0,angleToPulse(90)); 
//             pwm.setPWM(coksa2_s, 0,angleToPulse(90)); 
//             pwm.setPWM(coksa3_s, 0,angleToPulse(90)); 
//             pwm.setPWM(coksa4_s, 0,angleToPulse(90)); 
            
//             pwm.setPWM(tibia1_s, 0,angleToPulse(90));
//             pwm.setPWM(tibia2_s, 0,angleToPulse(90));
//             pwm.setPWM(tibia3_s, 0,angleToPulse(90));
//             pwm.setPWM(tibia4_s, 0,angleToPulse(90));
            
//             pwm.setPWM(femur1_s, 0,angleToPulse(90));
//             pwm.setPWM(femur2_s, 0,angleToPulse(90));
//             pwm.setPWM(femur3_s, 0,angleToPulse(90));
//             pwm.setPWM(femur4_s, 0,angleToPulse(90));
//             `;
//     }

//     moveDown() {
//         loopCode += `pwm.setPWM(tibia1_s, 0,angleToPulse(40));
//         pwm.setPWM(femur1_s, 0,angleToPulse(40));
//         pwm.setPWM(tibia2_s, 0,angleToPulse(40));
//         pwm.setPWM(femur2_s, 0,angleToPulse(40));
//         pwm.setPWM(tibia3_s, 0,angleToPulse(40));
//         pwm.setPWM(femur3_s, 0,angleToPulse(40));
//         pwm.setPWM(tibia4_s, 0,angleToPulse(40));
//         pwm.setPWM(femur4_s, 0,angleToPulse(40));`;
//     }

//     moveDownExtreme() {
//         loopCode += `pwm.setPWM(tibia3_s, 0,angleToPulse(10));
//         pwm.setPWM(femur3_s, 0,angleToPulse(0));
//         pwm.setPWM(tibia1_s, 0,angleToPulse(10));
//         pwm.setPWM(femur1_s, 0,angleToPulse(0));
//         pwm.setPWM(tibia2_s, 0,angleToPulse(10));
//         pwm.setPWM(femur2_s, 0,angleToPulse(0));
//         pwm.setPWM(tibia4_s, 0,angleToPulse(10));
//         pwm.setPWM(femur4_s, 0,angleToPulse(0));`;
//     }

//     moveUp() {
//         loopCode += `
//   pwm.setPWM(tibia1_s, 0,angleToPulse(120));
//   pwm.setPWM(tibia2_s, 0,angleToPulse(120));
//   pwm.setPWM(tibia3_s, 0,angleToPulse(120));
//   pwm.setPWM(tibia4_s, 0,angleToPulse(120));
// `;
//     }

//     twist() {
//         loopCode += `pwm.setPWM(coksa1_s, 0,angleToPulse(40));
//         pwm.setPWM(coksa2_s, 0,angleToPulse(40));
//         pwm.setPWM(coksa3_s, 0,angleToPulse(40));
//         pwm.setPWM(coksa4_s, 0,angleToPulse(40));
//         delay(500);
//         pwm.setPWM(coksa1_s, 0,angleToPulse(140));
//         pwm.setPWM(coksa2_s, 0,angleToPulse(140));
//         pwm.setPWM(coksa3_s, 0,angleToPulse(140));
//         pwm.setPWM(coksa4_s, 0,angleToPulse(140));
//         delay(500);`;
//     }

//     codeSetup() {
//         headerCode += `
// #include <Wire.h>
// #include <Adafruit_PWMServoDriver.h>

// #define PCA9685_ADDR 0x40 // I2C address of PCA9685 module
// Adafruit_PWMServoDriver pwm = Adafruit_PWMServoDriver(PCA9685_ADDR);

// #define SERVOMIN_puls 170
// #define SERVOMAX_puls 600
// #define SERVOMIN_angle 5
// #define SERVOMAX_angle 180

// const int coksa1_s= 0;
// const int coksa2_s= 4;
// const int coksa3_s= 8;
// const int coksa4_s= 12;

// const int tibia1_s= 1;
// const int tibia2_s= 5;
// const int tibia3_s= 9;
// const int tibia4_s= 13;

// const int femur1_s= 2;
// const int femur2_s= 6;
// const int femur3_s= 10;
// const int femur4_s= 14;

// uint16_t angleToPulse(int angle) {
//   return map(angle, SERVOMIN_angle, SERVOMAX_angle, SERVOMIN_puls, SERVOMAX_puls);
// }

// void home_pos(){
//   pwm.setPWM(coksa1_s, 0,angleToPulse(90)); 
//   pwm.setPWM(coksa2_s, 0,angleToPulse(90)); 
//   pwm.setPWM(coksa3_s, 0,angleToPulse(90)); 
//   pwm.setPWM(coksa4_s, 0,angleToPulse(90)); 
  
//   pwm.setPWM(tibia1_s, 0,angleToPulse(90));
//   pwm.setPWM(tibia2_s, 0,angleToPulse(90));
//   pwm.setPWM(tibia3_s, 0,angleToPulse(90));
//   pwm.setPWM(tibia4_s, 0,angleToPulse(90));
  
//   pwm.setPWM(femur1_s, 0,angleToPulse(90));
//   pwm.setPWM(femur2_s, 0,angleToPulse(90));
//   pwm.setPWM(femur3_s, 0,angleToPulse(90));
//   pwm.setPWM(femur4_s, 0,angleToPulse(90));
// }

// void down(){
//   pwm.setPWM(tibia1_s, 0,angleToPulse(40));
//   pwm.setPWM(femur1_s, 0,angleToPulse(40));
//   pwm.setPWM(tibia2_s, 0,angleToPulse(40));
//   pwm.setPWM(femur2_s, 0,angleToPulse(40));
//   pwm.setPWM(tibia3_s, 0,angleToPulse(40));
//   pwm.setPWM(femur3_s, 0,angleToPulse(40));
//   pwm.setPWM(tibia4_s, 0,angleToPulse(40));
//   pwm.setPWM(femur4_s, 0,angleToPulse(40));
// }

// void down_extrm(){
//   pwm.setPWM(tibia3_s, 0,angleToPulse(10));
//   pwm.setPWM(femur3_s, 0,angleToPulse(0));
//   pwm.setPWM(tibia1_s, 0,angleToPulse(10));
//   pwm.setPWM(femur1_s, 0,angleToPulse(0));
//   pwm.setPWM(tibia2_s, 0,angleToPulse(10));
//   pwm.setPWM(femur2_s, 0,angleToPulse(0));
//   pwm.setPWM(tibia4_s, 0,angleToPulse(10));
//   pwm.setPWM(femur4_s, 0,angleToPulse(0));
// }

// void up(){
//   pwm.setPWM(tibia1_s, 0,angleToPulse(120));
//   pwm.setPWM(tibia2_s, 0,angleToPulse(120));
//   pwm.setPWM(tibia3_s, 0,angleToPulse(120));
//   pwm.setPWM(tibia4_s, 0,angleToPulse(120));
// }

// void twist(){
//   pwm.setPWM(coksa1_s, 0,angleToPulse(40));
//   pwm.setPWM(coksa2_s, 0,angleToPulse(40));
//   pwm.setPWM(coksa3_s, 0,angleToPulse(40));
//   pwm.setPWM(coksa4_s, 0,angleToPulse(40));
//   delay(500);
//   pwm.setPWM(coksa1_s, 0,angleToPulse(140));
//   pwm.setPWM(coksa2_s, 0,angleToPulse(140));
//   pwm.setPWM(coksa3_s, 0,angleToPulse(140));
//   pwm.setPWM(coksa4_s, 0,angleToPulse(140));
//   delay(500);
//   home_pos();
// }`;
//         setupCode += `
// pwm.begin();
// pwm.setPWMFreq(50); // Set the PWM frequency to 50 Hz
// home_pos(); // Initialize servos to home position
//         `;
//         loopCode += `void loop() {\n// Empty loop as actions are called directly\n}\n`;
//     }
// }

// module.exports = Scratch3ArduinoUnoBlocks;

const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const codeGeneration = require('../codeGeneration');
let setupCode = '';
let loopCode = '';
let defineCode = '';
let bodyCode = '';
let codeContext = 'setup';
const definedFunctions = new Set();
const definedServos = new Set();

class Scratch3RoboticSpiderBlocks {
  constructor(runtime) {
    this.runtime = runtime;
    codeContext = localStorage.getItem('codeContext');
  }

  getInfo() {
    return {
      id: 'spider',
      name: formatMessage({
        id: 'spider.categoryName',
        default: 'Robotic Spider',
        description: 'Extension to control a robotic spider based on Arduino.'
      }),
      blocks: [
        {
          opcode: 'connectToSpider',
          blockType: BlockType.COMMAND,
          text: formatMessage({
            id: 'spider.connectToSpider',
            default: 'Connect to Robotic Spider',
            description: 'Connnect to robotic spider.'
          }),
          func: 'connectToSpider'
        },
        {
          opcode: 'initializeServo',
          blockType: BlockType.COMMAND,
          text: formatMessage({
            id: 'spider.initializeServo',
            default: 'Define intial values',
            description: 'Initialize servos in Spider.'
          }),
          func: 'initializeServo'
        },
        {
          opcode: 'setServo',
          blockType: BlockType.COMMAND,
          text: formatMessage({
            id: 'spider.setServo',
            default: 'Connect the legs',
            description: 'Attach a spider part to the specified pin.'
          }),
          func: 'setServo'
        },
        {
          opcode: 'moveleg',
          blockType: BlockType.COMMAND,
          text: formatMessage({
            id: 'spider.moveleg',
            default: 'Move coxa by [degree1] fimure by [degree2] tibia by [degree3] of [leg_num]',
            description: 'Attach a servo to the specified pin.'
          }),
          arguments: {
            degree1: {
              type: ArgumentType.ANGLE,
              defaultValue: 0
            },
            degree2: {
              type: ArgumentType.ANGLE,
              defaultValue: 0
            },
            degree3: {
              type: ArgumentType.ANGLE,
              defaultValue: 0
            },
            leg_num: {
              type: ArgumentType.STRING,
              menu: 'legnumMenu',
              defaultValue: 'leg 1'
            }
          },
        },
        {
          opcode: 'moveAxis',
          blockType: BlockType.COMMAND,
          text: formatMessage({
            id: 'spider.moveAxis',
            default: 'Move spider in [axis] axis',
            description: 'Move the axis by the specified degree.'
          }),
          arguments: {
            axis: {
              type: ArgumentType.STRING,
              menu: 'axisMenu',
              defaultValue: 'X'
            }
          },
        },
        {
          opcode: 'moveForward',
          blockType: BlockType.COMMAND,
          text: formatMessage({
            id: 'spider.moveForward',
            default: 'Move spider forward by [steps] steps',
            description: 'Move the spider forward.'
          }),
          arguments: {
            steps: {
              type: ArgumentType.STRING,
              defaultValue: 1
            },
            // direction: {
            //   type: ArgumentType.STRING,
            //   menu: 'directionMenu',
            //   defaultValue: 'forward'
            // }
          },
        },
        {
          opcode: 'moveLeftRight',
          blockType: BlockType.COMMAND,
          text: formatMessage({
            id: 'spider.moveLeftRight',
            default: 'Move spider [side] by [steps] steps',
            description: 'Move the spider left or right.'
          }),
          arguments: {
            steps: {
              type: ArgumentType.STRING,
              defaultValue: 1
            },
            side: {
              type: ArgumentType.STRING,
              menu: 'sideMenu',
              defaultValue: 'left'
            }
          },
        },
        {
          opcode: 'moveToHome',
          blockType: BlockType.COMMAND,
          text: formatMessage({
            id: 'spider.moveToHome',
            default: 'Move spider to home position',
            description: 'moves the spider to home position.'
          }),
          func: 'moveToHome'
        },
        // Add this to the blocks array in getInfo()
        {
          opcode: 'doAction',
          blockType: BlockType.COMMAND,
          text: formatMessage({
            id: 'spider.doAction',
            default: 'Do action [name]',
            description: 'Perform a spider action'
          }),
          arguments: {
            name: {
              type: ArgumentType.STRING,
              menu: 'actionMenu',
              defaultValue: 'hello'
            }
          }
        },
      ],
      menus: {
        partsMenu: {
          items: ['cocsa', 'fimure', 'tibia']
        },
        pinMenu: {
          items: ['2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13']
        },
        legnumMenu: {
          items: ['leg 1', 'leg 2', 'leg 3', 'leg 4']
        },
        axisMenu: {
          items: ['X', 'Y', 'Z']
        },
        directionMenu: {
          items: ['forward', 'backward']
        },
        sideMenu: {
          items: ['left', 'right']
        },
        chanlenumMenu: {
          items: ['0', '1', '2', '4', '5', '6', '8', '9', '10', '12', '13', '14']
        },
        actionMenu: {
          items: ['hello', 'twist']
        }
      }
    };
  }


  resetCode() {
    setupCode = '';
    loopCode = '';
    defineCode = '';
    bodyCode = '';
  }

  full_reset() {
    setupCode = '';
    loopCode = '';
    defineCode = '';
    bodyCode = '';
    definedServos.clear();
    definedFunctions.clear();
    codeGeneration.resetCode();
    console.log('Code has been reset.');
  }

  accumulateCode() {
    codeGeneration.accumulateCode(defineCode, bodyCode, setupCode, loopCode);
  }

  connectToSpider() {
    if (!definedServos.has('initcontroller')) {
      setupCode += `pwm.begin();
  pwm.setPWMFreq(60);`
      definedServos.add('initcontroller')
    }
    this.accumulateCode();
    this.resetCode();
  }

  initializeServo() {
    if (!definedServos.has('initval')) {
      defineCode += `#define SERVOMIN_puls 170
#define SERVOMAX_puls 600
#define SERVOMIN_angle 0
#define SERVOMAX_angle 180`;
      definedServos.add('initval');
    }
    this.accumulateCode();
    this.resetCode();
  }

  setServo() {
    // Create the define statement
    const codetoadd = `#define leg1_cocsa 0
#define leg1_fimure 1
#define leg1_tibia 2

#define leg2_cocsa 4
#define leg2_fimure 5
#define leg2_tibia 6

#define leg3_cocsa 8
#define leg3_fimure 9
#define leg3_tibia 10

#define leg4_cocsa 12
#define leg4_fimure 13
#define leg4_tibia 14

uint16_t angleToPulse(int angle) {
  return map(angle, SERVOMIN_angle, SERVOMAX_angle, SERVOMIN_puls, SERVOMAX_puls);
}`;

    if (!definedServos.has('legconnect')) {
      defineCode += codetoadd;

      // Add to the set of defined servos to track what's been configured
      definedServos.add('legconnect');
    }

    this.accumulateCode();
    this.resetCode();
  }
  moveleg(args) {

  }
  moveAxis(args) {
    const axis = args.axis;
    console.log(axis);
  }
  moveForward(args) {
    const steps = args.steps;
    const codetoadd = `void init_for(){
  pwm.setPWM(leg1_cocsa, 0, angleToPulse(90));
  pwm.setPWM(leg2_cocsa, 0, angleToPulse(80));
  }


void move_f(){
    pwm.setPWM(leg1_cocsa, 0, angleToPulse(120));
    pwm.setPWM(leg1_fimure, 0, angleToPulse(80));
    delay(100);
    pwm.setPWM(leg1_fimure, 0, angleToPulse(120));
    pwm.setPWM(leg1_tibia, 0, angleToPulse(85));
    delay(100);
    pwm.setPWM(leg1_cocsa, 0, angleToPulse(105));
    pwm.setPWM(leg1_fimure, 0, angleToPulse(100));
    pwm.setPWM(leg1_tibia, 0, angleToPulse(45));
    
    pwm.setPWM(leg2_cocsa, 0, angleToPulse(65));
    
    pwm.setPWM(leg3_cocsa, 0, angleToPulse(135));
    pwm.setPWM(leg3_fimure, 0, angleToPulse(70));
    pwm.setPWM(leg3_tibia, 0, angleToPulse(75));
    
    pwm.setPWM(leg4_cocsa, 0, angleToPulse(85));
    delay(100);
    pwm.setPWM(leg3_cocsa, 0, angleToPulse(100));
    pwm.setPWM(leg3_fimure, 0, angleToPulse(110));
    pwm.setPWM(leg3_tibia, 0, angleToPulse(45));
    delay(100);
    pwm.setPWM(leg3_fimure, 0, angleToPulse(90));
    
    pwm.setPWM(leg4_cocsa, 0, angleToPulse(55));
    pwm.setPWM(leg4_fimure, 0, angleToPulse(90));
    pwm.setPWM(leg4_tibia, 0, angleToPulse(75));
    delay(100);
    pwm.setPWM(leg4_fimure, 0, angleToPulse(70));
    delay(100);
    pwm.setPWM(leg1_cocsa, 0, angleToPulse(90));
    
    pwm.setPWM(leg2_cocsa, 0, angleToPulse(50));
    pwm.setPWM(leg2_fimure, 0, angleToPulse(110));
    pwm.setPWM(leg2_tibia, 0, angleToPulse(75));
    
    pwm.setPWM(leg3_cocsa, 0, angleToPulse(120));
    
    pwm.setPWM(leg4_cocsa, 0, angleToPulse(70));
    pwm.setPWM(leg4_fimure, 0, angleToPulse(70));
    pwm.setPWM(leg4_tibia, 0, angleToPulse(45));
    delay(100);
    pwm.setPWM(leg2_cocsa, 0, angleToPulse(80));
    pwm.setPWM(leg2_fimure, 0, angleToPulse(80));
    delay(100);
    pwm.setPWM(leg2_tibia, 0, angleToPulse(45));
    pwm.setPWM(leg2_fimure, 0, angleToPulse(100));
  }
    
 void move_for_steps(int steps) {
  init_for();
    delay(100);
    for (int i = 0; i < steps; i++) {
        move_f(); // Execute one full step forward
        delay(100); // Delay between steps to ensure smooth motion
    }
}`
    if (!definedFunctions.has('forward')) {
      bodyCode += codetoadd;
      definedFunctions.add('forward')
    }


    setupCode += ` move_for_steps(${steps});`;
    this.accumulateCode();
    this.resetCode();
  }
  moveLeftRight(args) {
    const steps = args.steps;
    const side = args.side;
    console.log(steps, side);
  }

  moveToHome() {
    const codetoadd = `void ho_me(){
  pwm.setPWM(leg1_cocsa, 0, angleToPulse(90));
  pwm.setPWM(leg1_fimure, 0, angleToPulse(90));
  pwm.setPWM(leg1_tibia, 0, angleToPulse(90));
  
  pwm.setPWM(leg2_cocsa, 0, angleToPulse(90));
  pwm.setPWM(leg2_fimure, 0, angleToPulse(90));
  pwm.setPWM(leg2_tibia, 0, angleToPulse(90));
  
  pwm.setPWM(leg3_cocsa, 0, angleToPulse(90));
  pwm.setPWM(leg3_fimure, 0, angleToPulse(80));
  pwm.setPWM(leg3_tibia, 0, angleToPulse(90));
  
  pwm.setPWM(leg4_cocsa, 0, angleToPulse(90));
  pwm.setPWM(leg4_fimure, 0, angleToPulse(80));
  pwm.setPWM(leg4_tibia, 0, angleToPulse(100));
  }`;

    if (!definedFunctions.has('ho_me')) {
      bodyCode += codetoadd;
      definedFunctions.add('ho_me');
    }
    if (localStorage.getItem('codeContext') === 'setup') {
      setupCode += ` ho_me();`;
    } else if (localStorage.getItem('codeContext') === 'loop') {
      loopCode += ` ho_me();`;
    }
    this.accumulateCode();
    this.resetCode();
  }

  // Add this method to the class
  doAction(args) {
    const action = args.name;
    const actionCode = {
        hello: `void hello() {
            pwm.setPWM(leg2_cocsa, 0, angleToPulse(130));
            pwm.setPWM(leg1_cocsa, 0, angleToPulse(40));
            pwm.setPWM(leg2_fimure, 0, angleToPulse(60));
            pwm.setPWM(leg2_tibia, 0, angleToPulse(180));
            delay(2000);
        }
        
        void wave() {
            pwm.setPWM(leg2_cocsa, 0, angleToPulse(20));
            delay(500);
            pwm.setPWM(leg2_cocsa, 0, angleToPulse(90));
            delay(500);
            pwm.setPWM(leg2_cocsa, 0, angleToPulse(160));
            delay(500);
            pwm.setPWM(leg2_cocsa, 0, angleToPulse(90));
            delay(500);
        }`,
        
        twist: `void twist() {
            pwm.setPWM(leg1_cocsa, 0, angleToPulse(60));
            pwm.setPWM(leg2_cocsa, 0, angleToPulse(60));
            pwm.setPWM(leg3_cocsa, 0, angleToPulse(60));
            pwm.setPWM(leg4_cocsa, 0, angleToPulse(60));
            delay(500);
            pwm.setPWM(leg1_cocsa, 0, angleToPulse(120));
            pwm.setPWM(leg2_cocsa, 0, angleToPulse(120));
            pwm.setPWM(leg3_cocsa, 0, angleToPulse(120));
            pwm.setPWM(leg4_cocsa, 0, angleToPulse(120));
            delay(500);
        }`
    };

    if (!definedFunctions.has(action)) {
        bodyCode += actionCode[action];
        definedFunctions.add(action);
        if (action === 'hello') {
            definedFunctions.add('wave');
        }
    }

    if (action === 'hello') {
        if (localStorage.getItem('codeContext') === 'setup') {
            setupCode += ` hello();\n wave();`;
        } else if (localStorage.getItem('codeContext') === 'loop') {
            setupCode += ` hello();`;
            loopCode += ` wave();`;
        }
    } else {
        if (localStorage.getItem('codeContext') === 'setup') {
            setupCode += ` ${action}();`;
        } else if (localStorage.getItem('codeContext') === 'loop') {
            loopCode += ` ${action}();`;
        }
    }

    this.accumulateCode();
    this.resetCode();
  }
}

module.exports = Scratch3RoboticSpiderBlocks;